import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QRCode from "qrcode";
import { useMemo } from "react";
const QUIET = 2; // modules of quiet zone on each side
/**
 * Real QR code as inline SVG (encoded by `qrcode`, drawn with design tokens so it follows light/dark).
 * Renders nothing when the value is empty or too long to encode; callers keep the text as a fallback.
 */
export function QrCode({ value, size = 192, label = "QR code", className }) {
    const model = useMemo(() => {
        if (!value)
            return null;
        try {
            const { modules } = QRCode.create(value, { errorCorrectionLevel: "M" });
            const n = modules.size;
            let d = "";
            for (let y = 0; y < n; y++) {
                for (let x = 0; x < n; x++)
                    if (modules.get(x, y))
                        d += `M${x + QUIET} ${y + QUIET}h1v1h-1z`;
            }
            return { n: n + QUIET * 2, d };
        }
        catch {
            return null;
        }
    }, [value]);
    if (!model)
        return null;
    return (_jsxs("svg", { className: ["lumora-qr", className].filter(Boolean).join(" "), role: "img", "aria-label": label, width: size, height: size, viewBox: `0 0 ${model.n} ${model.n}`, shapeRendering: "crispEdges", "data-lumora-qr": "", children: [_jsx("rect", { width: model.n, height: model.n, style: { fill: "var(--lumora-surface-raised, Canvas)" } }), _jsx("path", { d: model.d, style: { fill: "var(--lumora-ink-primary, CanvasText)" } })] }));
}
//# sourceMappingURL=QrCode.js.map